const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { appointments: appointmentApi } = require('@doctoroncallcom/api')
const {
  GET_USER_APPOINTMENTS_LIST,
  GET_USER_APPOINTMENT_DETAILS,
  GET_DOCTOR_APPOINTMENT_LIST,
  GET_DOCTOR_APPOINTMENT_OVERVIEW,
} = require('./constants')

const {
  userAppointmentsListSuccess,
  userAppointmentsListError,
  getuserAppointmentDetailsSuccess,
  getuserAppointmentDetailsError,
  getDoctorAppointmentListSuccess,
  getDoctorAppointmentListError,
  getDoctorAppointmentOverviewSuccess,
  getDoctorAppointmentOverviewError,
} = require('./actions')

const getAppointment = (action$, state$, { api }) => action$.pipe(
  ofType(GET_USER_APPOINTMENTS_LIST),
  mergeMap(action => appointmentApi.getAppointmentsListApi(api, {
    userId: action.payload.userId,
    type: action.payload.type,
  })
    .then(response => userAppointmentsListSuccess(response.data))
    .catch(error => userAppointmentsListError(error))),
)

const getAppointmentDetails = (action$, state$, { api }) => action$.pipe(
  ofType(GET_USER_APPOINTMENT_DETAILS),
  mergeMap(action => appointmentApi.getAppointmentDetailsApi(api, action.payload.id)
    .then(response => getuserAppointmentDetailsSuccess(response.data))
    .catch(error => getuserAppointmentDetailsError(error))),
)

const getDoctorAppointmentList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_DOCTOR_APPOINTMENT_LIST),
  mergeMap(action => appointmentApi.getDoctorAppointmentListApi(api, {
    doctorId: action.payload.doctorId,
    type: action.payload.type,
    from: action.payload.from,
    to: action.payload.to,
  })
    .then(response => getDoctorAppointmentListSuccess(response.data))
    .catch(error => getDoctorAppointmentListError(error))),
)

const getDoctorAppointmentOverview = (action$, state$, { api }) => action$.pipe(
  ofType(GET_DOCTOR_APPOINTMENT_OVERVIEW),
  mergeMap(action => appointmentApi.getDoctorAppointmentOverviewApi(api, action.payload.apptID, {
    doctorId: action.payload.doctorId,
  })
    .then(response => getDoctorAppointmentOverviewSuccess(response.data))
    .catch(error => getDoctorAppointmentOverviewError(error))),
)

module.exports = {
  getAppointment,
  getAppointmentDetails,
  getDoctorAppointmentList,
  getDoctorAppointmentOverview,
}
